import { render, staticRenderFns } from "./merchant.vue?vue&type=template&id=77267d3a&scoped=true&"
import script from "./merchant.vue?vue&type=script&lang=ts&"
export * from "./merchant.vue?vue&type=script&lang=ts&"
import style0 from "./merchant.vue?vue&type=style&index=0&id=77267d3a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77267d3a",
  null
  
)

export default component.exports